import type { NavItemType } from 'types/menu';
import type { UserData } from 'types/user';

export type MenuAccess = Pick<UserData, 'enabledFeatures' | 'permissions'> | null | undefined;

export function isMenuItemVisible(item: NavItemType, user: MenuAccess): boolean {
    const hasRequiredFeature = !item.requiredFeature || !!user?.enabledFeatures?.includes(item.requiredFeature);
    const hasRequiredPermission =
        !item.permissions || !!user?.permissions?.some(({ code }) => item.permissions?.includes(code));

    return hasRequiredFeature && hasRequiredPermission;
}

/** A menu section shows when at least one of its links does. */
export function isSectionVisible(section: NavItemType, user: MenuAccess): boolean {
    return isMenuItemVisible(section, user) && !!section.children?.some((link) => isMenuItemVisible(link, user));
}
